//ERRORS
export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

//CRASHES
export const SET_CRASHES = "SET_CRASHES";
export const CLEAR_CRASHES = "CLEAR_CRASHES";

//MESSAGE
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

//AUTH
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";

//NOTES
export const GET_NOTES = "GET_NOTES";
export const CREATE_NOTE = "CREATE_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const NOTE_LIMIT_REACHED = "NOTE_LIMIT_REACHED";
export const CLEAR_NOTE_LIMIT = "CLEAR_NOTE_LIMIT";

//BILLING
export const GET_PLANS = "GET_PLANS";

